import { cn } from "@/lib/utils";

interface Props {
    words: string;
    description?: string;
    children?: React.ReactNode;
    /** Softer, smaller heading when showing `form_caption` on ePRO pages. */
    headingVariant?: "default" | "caption" | "compact";
    /** Use `center` to centre the heading on small screens (marketing-style pages). Default is left-aligned everywhere. */
    align?: "default" | "left" | "center";
    className?: string;
}

const Title = ({ words, description, children, headingVariant = "default", align = "default", className }: Props) => {
    const alignClass = align === "center" ? "text-center md:text-left" : align === "left" ? "text-left" : "text-left";
    const headingClass =
        headingVariant === "compact"
            ? "font-semibold text-slate-900 dark:text-slate-100 text-xl sm:text-2xl tracking-tight"
            : headingVariant === "caption"
              ? "font-medium text-slate-500 dark:text-slate-400 text-lg md:text-xl tracking-normal"
              : "font-bold text-slate-900 dark:text-slate-100 text-3xl md:text-4xl";

    const wrapperMarginClass =
        headingVariant === "compact"
            ? "mb-0 w-full"
            : headingVariant === "caption"
              ? "mb-1 w-full"
              : "mb-4 md:mb-8 w-full";

    return (
        <div
            data-title-source={headingVariant === "caption" ? "caption" : "name"}
            className={cn("flex flex-col mx-auto w-full", wrapperMarginClass, className)}
        >
            <h1 className={`${headingClass} ${alignClass}`}>{words}</h1>
            {description && (
                <p
                    className={cn(
                        alignClass,
                        headingVariant === "compact"
                            ? "mt-1.5 text-sm text-slate-600 dark:text-slate-400"
                            : "mt-2 text-md text-slate-700 dark:text-slate-400"
                    )}
                >
                    {description}
                </p>
            )}
            {children}
        </div>
    );
};

export default Title;
